<div class="d-flex justify-content-between align-items-center chat-header pl-2 pr-1 py-1"
  [class.clickable]="showClickForInfo" (click)="onOpenInfo()">
  <div class="d-flex align-items-center">
    <div class="d-flex align-items-center">
      <div class="mobile-back-btn d-md-none mb-2" *ngIf="!showSearchBackButton" (click)="onBack($event)">
        <svg style="color: #7d96d7" xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24">
          <path fill="currentColor"
            d="M6.325 12.85q-.225-.15-.337-.375T5.874 12t.113-.475t.337-.375l8.15-5.175q.125-.075.263-.112T15 5.825q.4 0 .7.288t.3.712v10.35q0 .425-.3.713t-.7.287q-.125 0-.262-.038t-.263-.112z" />
        </svg>
      </div>

      <!-- Search Results Back Button -->
      <div class="search-back-btn mr-1" *ngIf="showSearchBackButton" (click)="onSearchBack($event)"
        title="Back to search results">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
          class="feather feather-arrow-left">
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
      </div>

      <div class="avatar-container">
        <img [src]="image" (error)="handleProfileImageError($event)" alt="user" class="user-profile-img" />
      </div>
    </div>

    <div class="ml-2 info-container">
      <p class="user-list-name" [class.group-chat-name]="isGroup">
        {{ title }}
      </p>

      <div class="d-flex align-items-center status-container">
        @if (!isGroup && isOnline && !connectionStatus) {
        <span class="online-indicator" title="Online"></span>
        }
        <p class="status-text">
          @if (connectionStatus) {
          <span class="connection-status-text">{{ connectionStatus }}</span>
          } @else if (typingText) {
          <span class="typing-indicator-text">{{ typingText }}</span>
          } @else {
          @if (isGroup) {
          {{ memberDisplayNames.join(", ") }}
          } @else {
          {{ status }}
          }
          }
        </p>
      </div>
    </div>
  </div>

  <div class="chat-header-actions d-flex align-items-center">
    <div class="chat-header-icon d-flex align-items-center mr-1" (click)="onQuickSearch($event)" title="Search messages">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#454852" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>
    </div>

    <div class="chat-header-icon position-relative d-flex align-items-center" (click)="onToggleMenu($event)">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
          stroke="#454852" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
          stroke="#454852" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
          stroke="#454852" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>

      @if (showMenu) {
      <div class="dropdown-menu show three-dot" style="right: 0; left: auto; top: 100%">
        <button class="dropdown-item" (click)="onQuickSearch($event)">
          <p>Search</p>
        </button>

        <button class="dropdown-item" [disabled]="!hasMessages" [class.disabled-menu-item]="!hasMessages"
          (click)="onClearChat($event)">
          <p>clear chat</p>
        </button>

        <button class="dropdown-item" (click)="onStarredClick($event)">
          <p>starred</p>
        </button>

        <button class="dropdown-item" [disabled]="!hasMessages" [class.disabled-menu-item]="!hasMessages"
          (click)="onExportChat('txt', $event)">
          <p>Export chat (.txt)</p>
        </button>

        <button class="dropdown-item" [disabled]="!hasMessages" [class.disabled-menu-item]="!hasMessages"
          (click)="onExportChat('json', $event)">
          <p>Export chat (.json)</p>
        </button>

        @if (isGroup) {
        @if (!isExited) {
        <button class="dropdown-item" (click)="onExitGroup($event)">
          <p>Exit group</p>
        </button>
        }
        <button class="dropdown-item text-danger" (click)="onRemoveGroup($event)">
          <p>Remove from my chats</p>
        </button>
        @if (isLinkAdmin) {
        <button class="dropdown-item text-danger" (click)="onDeleteGroup($event)">
          <p>Delete for everyone</p>
        </button>
        }
        }
      </div>
      }
    </div>
  </div>
</div>